import { zodResolver } from '@hookform/resolvers/zod';
import { Autocomplete, Box, Button, CircularProgress, Grid, Stack, TextField, Typography } from '@mui/material';
import { ContactIM, ContactIMSchema } from '@tto/shared-models';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useCreateUnassignedContactMutation } from 'src/services/restApi/queries/contact.service';
import { useDialogStore } from 'src/store/dialog/dialogStore';

export function CreateContactModal() {
  const [createContact, { isLoading }] = useCreateUnassignedContactMutation();

  const { closeDialog, openDialog } = useDialogStore((state) => state);

  const onSubmit = async (data: ContactIM) => {
    try {
      // Always create the license first
      await createContact(ContactIMSchema.parse(data)).unwrap();
    } catch (err) {
      toast.error('Contact creation failed. Please try again later.');
    }

    closeDialog();
  };

  const { handleSubmit, control, register, formState, setValue, reset, watch } = useForm<ContactIM>({
    resolver: zodResolver(ContactIMSchema),
  });

  return (
    <Box>
      <Typography paddingBottom={2} align={'center'} variant='h3'>
        Add a Contact
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} paddingBottom={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size='small'
              label='Name'
              {...register('name')}
              error={!!formState.errors.name}
              helperText={
                typeof formState.errors.name?.message === 'string' ? formState.errors.name.message : undefined
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size='small'
              label='Email'
              {...register('email')}
              error={!!formState.errors.email}
              helperText={
                typeof formState.errors.email?.message === 'string' ? formState.errors.email.message : undefined
              }
            />
          </Grid>
        </Grid>

        <Stack direction='row' justifyContent={'flex-end'} paddingTop={1}>
          <Button onClick={() => closeDialog()}>Cancel</Button>
          <Button
            variant={'contained'}
            type='submit'
            startIcon={isLoading ? <CircularProgress size={18} /> : undefined}
            disabled={isLoading}
          >
            {isLoading ? 'Submitting...' : 'Submit'}
          </Button>
        </Stack>
      </form>
    </Box>
  );
}
